import React, { PureComponent } from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import renderInputField from '../../../shared/components/form/renderInput';
import {withTranslation} from "react-i18next";

class SocialProfiles extends PureComponent {

  render() {
    const { handleSubmit, blog, t } = this.props;

    return (
      <Col xs={12} md={12} lg={12} xl={12}>
        <Card>
          <CardBody>
          <div className="card__title">
              <h5 className="bold-text">{t('settings.social.title')}</h5>
              {/* <h5 className="subhead">Optional settings to make your blog look better when sharing on social media</h5> */}

            </div>
            <form className="form form--horizontal" onSubmit={handleSubmit}>

              <div className="form__form-group">
                <span className="form__form-group-label">Facebook:</span>
                <div className="form__form-group-field">
                  <Field
                    name="link_facebook"
                    component={renderInputField}
                    type="text"
                    placeholder="https://facebook.com/..."
                    value={blog.link_facebook}
                  />
                </div>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label">Twitter:</span>
                <div className="form__form-group-field">
                  <Field
                    name="link_twitter"
                    component={renderInputField}
                    type="text"
                    placeholder="https://twitter.com/..."
                    value={blog.link_twitter}
                  />
                </div>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label">Instagram:</span>
                <div className="form__form-group-field">
                  <Field
                    name="link_instagram"
                    component={renderInputField}
                    type="text"
                    placeholder="https://instagram.com/..."
                    value={blog.link_instagram}
                  />
                </div>
              </div>
              
            </form>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: 'blog_settings', // a unique identifier for this form
  enableReinitialize: true
})(withTranslation('dashboard')(SocialProfiles));
